<template>
    <div class="card">
        <btn-iniciar-consistencia v-if="!iniciarConsistencia" @click="mostrarConsistencia()" class="mb-4 flex align-items-center justify-content-center" />
        <btn-voltar v-if="iniciarConsistencia" @click="fechar" class="mb-4" />

        <TabView v-if="iniciarConsistencia">
            <TabPanel header="Recursos Financeiros">
                <recursos-financeiros :recursosFinanceiros="consistencia.recursosFinanceiros" />
            </TabPanel>
            <TabPanel header="Reconhecimento de Receitas">
                <reconhecimento-de-receitas :reconhecimentoReceitas="consistencia.reconhecimentoReceitas" />
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import BtnIniciarConsistencia from './BtnIniciarConsistencia';
import RecursosFinanceiros from './RecursosFinanceiros';
import ReconhecimentoDeReceitas from './ReconhecimentoDeReceitas';
import Services from './services';

export default {
    components: {
        BtnIniciarConsistencia,
        RecursosFinanceiros,
        ReconhecimentoDeReceitas,
    },
    data() {
        return {
            iniciarConsistencia: false,
            consistencia: {
                recursosFinanceiros: {
                    aportes: {},
                    planoDeTrabalho: {},
                },
                reconhecimentoReceitas: {
                    fontes: {},
                    fontesReceitas: {},
                    extratos: {},
                    vigencia: {},
                },
            },
        };
    },
    props: {
        convenio: {
            type: Object,
        },
    },
    methods: {
        async mostrarConsistencia() {
            this.$store.dispatch('addRequest');

            Services.obterRotinaConsistencia(this.$route.params.id, this.convenio.cpfCnpj).then((response) => {
                if (!response.success || !response.data) {
                    this.$store.dispatch('removeRequest');
                    return;
                }

                this.consistencia.recursosFinanceiros.aportes = response.data.aportes;
                this.consistencia.recursosFinanceiros.planoDeTrabalho = response.data.planoDeTrabalho;

                this.consistencia.reconhecimentoReceitas.fontes = response.data.fontes;
                this.consistencia.reconhecimentoReceitas.fontesReceitas = response.data.fontesReceitas;
                this.consistencia.reconhecimentoReceitas.extratos = response.data.extratos;
                this.consistencia.reconhecimentoReceitas.vigencia = response.data.vigencia;

                this.iniciarConsistencia = !this.iniciarConsistencia;
                this.$store.dispatch('removeRequest');
            });
        },
        fechar() {
            this.iniciarConsistencia = !this.iniciarConsistencia;
        },
    },
};
</script>
